import { render, staticRenderFns } from "./DocusignAddTemplate.vue?vue&type=template&id=79823972&"
import script from "./DocusignAddTemplate.vue?vue&type=script&lang=ts&"
export * from "./DocusignAddTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports